import { render, staticRenderFns } from "./AxHeaderSearch.vue?vue&type=template&id=53292b3c&scoped=true&"
import script from "./AxHeaderSearch.vue?vue&type=script&lang=ts&"
export * from "./AxHeaderSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AxHeaderSearch.vue?vue&type=style&index=0&id=53292b3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53292b3c",
  null
  
)

export default component.exports